namespace $ {

	export function $shm_hitalama_map_runtime_sql_process( map: $shm_hitalama_map, source: string ) {
		const files: $shm_hitalama_file[] = []
		const sql = source.replaceAll(new RegExp('\\$'+'value([^\\s]+)', 'gi'), reference=> {
			const id = reference.slice(8,-2)
			const file = map.widget(id).File()?.remote()
			if(!file) throw new Error(`Виджет «${id}» не содержит файл для SQL-запроса`)
			files.push(file)
			const filename = file.title()
			const path = $shm_duckdb_sql_string(filename)
			return /\.parquet$/i.test(filename) ? `parquet_scan(${path})` : path
		})
		return { sql, files }
	}

	export function $shm_hitalama_map_runtime_sql_code( code: string ) {
		return `
			const { files, sql } = $${''}arg;
			const result = $shm_duckdb.files_query( files, sql );
			${code}
		`
	}
}
